import { ContextMenu, type ContextMenuProps } from '@affine/component';
import { useCallback, useRef } from 'react';

import type { StreamLainDropdownAnchor } from './chrome';
import { RadixDropdownPanelChrome } from './radix-chrome';

/** Context menu with the shared StreamLain disclosure chrome. */
export function StreamLainContextMenu({
  contentProps,
  items,
  onContextMenu,
  ...props
}: ContextMenuProps) {
  const pointerRef = useRef({ x: 0, y: 0 });
  const triggerRef = useRef<StreamLainDropdownAnchor>({
    getBoundingClientRect: () =>
      DOMRect.fromRect({
        x: pointerRef.current.x,
        y: pointerRef.current.y,
        width: 0,
        height: 0,
      }),
  });
  const handleContextMenu = useCallback<
    NonNullable<ContextMenuProps['onContextMenu']>
  >(
    event => {
      pointerRef.current = { x: event.clientX, y: event.clientY };
      onContextMenu?.(event);
    },
    [onContextMenu]
  );

  return (
    <ContextMenu
      {...props}
      onContextMenu={handleContextMenu}
      contentProps={{
        collisionPadding: 8,
        ...contentProps,
      }}
      items={
        <RadixDropdownPanelChrome triggerRef={triggerRef}>
          {items}
        </RadixDropdownPanelChrome>
      }
    />
  );
}
